import React from "react";
import { Routes, Route } from "react-router";
import CustomerDevicesView from "./../components/CustomerDevicesView/CustomerDevicesView";
import MapViewContainer from "./MapViewContainer/MapViewContainer";
import AdminContainer from "./AdminContainer/AdminContainer";
import SensorViewContainer from "./SensorViewContainer/SensorViewContainer";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<CustomerDevicesView />} />
      <Route path="/map" element={<MapViewContainer />} />
      <Route path="/admin" element={<AdminContainer />} />
      <Route path="/sensorlist" element={<SensorViewContainer />} />
    </Routes>
  );
};

export default AppRoutes;
